// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.body{
    content: "";
    position: absolute;
    width: 100%;
    height: 958px;
    background-color: #f0f0f0;
}

body{
    background-color: #f0f0f0;
    color: #666666;
}

.code{
    width: 100%;
    height: 100%;
}

.logoContainer{
    margin-top: 20px;
    display: grid;
    grid-template-columns: 20% 60% 20%;
}

.logo p{
    text-align: center;
    font-weight: bold;
}

.logo img{
    width: 100%;
}

.qrBodyContainer{
    display: grid;
    grid-template-columns: 7% 86% 7%;
}

.qrBody{
    background-color: #ffff;
    box-shadow: 0 0 7px rgba(0, 0, 0, 0.177);
    border-radius: 50px;
    padding: 25px;

}

.qrBody h2{
    margin-top: 0px;
    margin-bottom: 15px;
    text-align: center;
}

.qrContainer{
    margin-left: 22%;
    margin-right: 22%;
    box-shadow: 0 0 7px rgba(0, 0, 0, 0.177);
    border-radius: 10px;
    padding: 5px;
}

.qrContainer img{
    width: 100%;
}

.statsContainer{
    text-align: center;
}

.statsContainer h3{
    margin-bottom: 0px;
}

.statsContainer hr{
    color: rgb(219, 219, 219);
    font-weight: 900;

}

.monthlyScans{
    color: #5ec268 !important;
    font-weight: 900;
    font-size: 50px;
    margin: 0px;
}

.rank{
    color: #50cdde !important;
    font-weight: 900;
    font-size: 50px;
    margin: 0px;
}

.bottomTabContainer{
    display: grid;
    grid-template-columns: 7% 86% 7%;
    position: absolute;
    bottom: 0px;
    left: 0px;
    right: 0px;

}

.bottomTab{
    background-color: #011589;
    height: 118px;
    border-radius: 25px 25px 0px 0px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;IACvB,wCAAwC;IACxC,mBAAmB;IACnB,aAAa;;AAEjB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,wCAAwC;IACxC,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;;AAEpB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,UAAU;;AAEd;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,gCAAgC;AACpC","sourcesContent":[".body{\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 958px;\n    background-color: #f0f0f0;\n}\n\nbody{\n    background-color: #f0f0f0;\n    color: #666666;\n}\n\n.code{\n    width: 100%;\n    height: 100%;\n}\n\n.logoContainer{\n    margin-top: 20px;\n    display: grid;\n    grid-template-columns: 20% 60% 20%;\n}\n\n.logo p{\n    text-align: center;\n    font-weight: bold;\n}\n\n.logo img{\n    width: 100%;\n}\n\n.qrBodyContainer{\n    display: grid;\n    grid-template-columns: 7% 86% 7%;\n}\n\n.qrBody{\n    background-color: #ffff;\n    box-shadow: 0 0 7px rgba(0, 0, 0, 0.177);\n    border-radius: 50px;\n    padding: 25px;\n\n}\n\n.qrBody h2{\n    margin-top: 0px;\n    margin-bottom: 15px;\n    text-align: center;\n}\n\n.qrContainer{\n    margin-left: 22%;\n    margin-right: 22%;\n    box-shadow: 0 0 7px rgba(0, 0, 0, 0.177);\n    border-radius: 10px;\n    padding: 5px;\n}\n\n.qrContainer img{\n    width: 100%;\n}\n\n.statsContainer{\n    text-align: center;\n}\n\n.statsContainer h3{\n    margin-bottom: 0px;\n}\n\n.statsContainer hr{\n    color: rgb(219, 219, 219);\n    font-weight: 900;\n\n}\n\n.monthlyScans{\n    color: #5ec268 !important;\n    font-weight: 900;\n    font-size: 50px;\n    margin: 0px;\n}\n\n.rank{\n    color: #50cdde !important;\n    font-weight: 900;\n    font-size: 50px;\n    margin: 0px;\n}\n\n.bottomTabContainer{\n    display: grid;\n    grid-template-columns: 7% 86% 7%;\n    position: absolute;\n    bottom: 0px;\n    left: 0px;\n    right: 0px;\n\n}\n\n.bottomTab{\n    background-color: #011589;\n    height: 118px;\n    border-radius: 25px 25px 0px 0px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
